// ============================================================================
// Cliente API para /api/admin/settings — flags de aplicación (tabla
// app_settings). Lectura: cualquier usuario autenticado. Escritura: roles
// admin (el backend la rechaza para el resto).
//
// Flags en uso:
//   factura_scan_enabled ('true'|'false') — botón "Escanear factura" en Compras.
// ============================================================================
import { api } from './client';

export type AppSettings = Record<string, string>;

export const FLAG_FACTURA_SCAN = 'factura_scan_enabled';
/** Módulo de calificaciones (QR post-pago) — add-on pago, default apagado. */
export const FLAG_RATINGS = 'ratings_module_enabled';
/** Módulo Personal (turnos de trabajadores) — default apagado. */
export const FLAG_STAFF = 'staff_module_enabled';
/** Módulo Cortesías (items regalados trackeados) — default apagado. */
export const FLAG_CORTESIAS = 'cortesias_module_enabled';
/** Módulo Combos (mig. 049) — feature nuevo, default apagado (oct-2026). */
export const FLAG_COMBOS = 'combos_module_enabled';

// --- Módulo Notificaciones (ago-2026) ---------------------------------------
/** JSON { inventario: [roles OCULTOS], reservas: [...], pedidos: [...] }.
 *  Semántica de EXCLUSIÓN: un rol listado NO ve esa alerta. Key/tipo ausente o
 *  rol no listado = la ve (default = comportamiento actual; roles legacy que
 *  no aparecen en la matriz nunca pierden alertas por accidente).
 *  El rol desarrollador siempre ve todo. */
export const SETTING_NOTIF_ROLES = 'notif_roles_config';
/** 'true'|'false' — interruptor maestro de correos automáticos. */
export const SETTING_NOTIF_EMAIL_ENABLED = 'notif_email_enabled';
/** 'true'|'false' — interruptor maestro de WhatsApp (Meta Cloud API). */
export const SETTING_NOTIF_WHATSAPP_ENABLED = 'notif_whatsapp_enabled';
/** Correos destino separados por coma. */
export const SETTING_NOTIF_EMAIL_DEST = 'notif_email_destinatarios';
/** JSON array de eventos que disparan correo (ej. scan_presupuesto_agotado). */
export const SETTING_NOTIF_EMAIL_EVENTOS = 'notif_email_eventos';

// --- Contacto de soporte (ago-2026) -----------------------------------------
/** Teléfono de soporte en formato internacional SIN '+' ni espacios
 *  (ej. '573001234567'). Vacío o ausente = no se ofrece el botón de WhatsApp.
 *  Antes acá había un número personal quemado en el código; se configura desde
 *  el módulo Notificaciones. */
export const SETTING_SOPORTE_WHATSAPP = 'soporte_whatsapp';
/** Correo de soporte, alternativa cuando no hay WhatsApp configurado. */
export const SETTING_SOPORTE_EMAIL = 'soporte_email';

export const getAppSettings = () => api.get<AppSettings>('/api/admin/settings');

export const setAppSetting = (key: string, value: string) =>
  api.put<{ key: string; value: string }>(`/api/admin/settings/${encodeURIComponent(key)}`, { value });
